import React, { ReactNode } from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

const CustomButton = styled(Button)({
  letterSpacing: "1px",
  backgroundColor: "#FB5012",
  textTransform: "none",
  fontFamily: "Opensans",
  fontWeight: "bold",
  padding: "11px 28px",
  borderRadius: "38px",
  "&:hover": {
    backgroundColor: "#FB5012",
  },
  "&.Mui-disabled": {
    backgroundColor: "rgba(65, 29, 16, 1)",
    color: "rgba(136, 51, 51, 1)",
    fontFamily: "Opensans",
    fontWeight: "bold",
  },
});

interface StyledButtonProps {
  children: ReactNode;
  [key: string]: any;
}

const StyledButton: React.FC<StyledButtonProps> = ({ children, ...props }) => {
  return (
    <CustomButton variant="contained" {...props}>
      {children}
    </CustomButton>
  );
};

export default StyledButton;
